import React from 'react';
import MenuButton from './MenuButton'
import '../stylesheets/Header.sass'

class Header extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			headerIsWhite: false,
			language: props.language
		}
		this.navigateTo = props.navigateTo
	}

	componentWillReceiveProps (props) {
		this.setState({language: props.language})
	}

	componentDidMount() {
    	window.addEventListener('scroll', this.handleScroll, true);
  	}

  	componentWillUnmount() {
    	window.removeEventListener('scroll', this.handleScroll);
  	}

	render () {
		return (
			<div className={"Header " + (this.state.headerIsWhite ? "white" : "")} onClick={() => {this.navigateTo("language")}}>
			<div className="Foreground">
			<MenuButton isBlack={this.state.headerIsWhite}></MenuButton>
			</div>
			</div>
			);
	} 

	handleScroll = () => {
		
		let scrollPosition = window.pageYOffset
		let innerHeight = window.innerHeight


		// Optimizing Performance a teeny tiny bit
		if((scrollPosition / innerHeight) > 1.1) {
			return
		} 

		if (!this.state.headerIsWhite) {			
			if ((scrollPosition / innerHeight) > 0.93) {
				this.setState({headerIsWhite: true})
			}
		} else {
			if ((scrollPosition / innerHeight) <= 0.93) {
				this.setState({headerIsWhite: false})
			}
		}

	}
}

export default Header;